import React, { Component } from "react";

import ArcaneIcon2 from "../DeckBuilderComponents/FilterComponents/ArcaneIcon2.png";
import ChaosIcon2 from "../DeckBuilderComponents/FilterComponents/ChaosIcon2.png";
import DivineIcon2 from "../DeckBuilderComponents/FilterComponents/DivineIcon2.png";
import NatureIcon2 from "../DeckBuilderComponents/FilterComponents/NatureIcon2.png";
import TechnologyIcon2 from "../DeckBuilderComponents/FilterComponents/TechnologyIcon2.png";

class Aspects extends Component {

  render() {

  var deckAspects = this.props.deckAspects;
    return (
      deckAspects.map(function(aspect, i){
        var imagepath = "";


        if (aspect.AspectIcon == "ArcaneIcon2")
        {
          imagepath = ArcaneIcon2
        }
        else if (aspect.AspectIcon == "ChaosIcon2")
        {
          imagepath = ChaosIcon2
        }
        else if (aspect.AspectIcon == "DivineIcon2")
        {
          imagepath = DivineIcon2
        }
        else if (aspect.AspectIcon == "NatureIcon2")
        {
          imagepath = NatureIcon2
        }
        else if (aspect.AspectIcon == "TechnologyIcon2")
        {
          imagepath = TechnologyIcon2
        }
        return (

          <img alt="aspects" src={imagepath} style={{height:25, width:25}} />
        )
      })
    );
  }
}

export default Aspects;



// WEBPACK FOOTER //
// ./src/DeckBuilderComponents/Aspects.js